import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=079b4220&scoped=true&"
import script from "./UserDialog.vue?vue&type=script&lang=js&"
export * from "./UserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b4220",
  null
  
)

export default component.exports